module.exports = "/_next/static/images/f712d0101e137ec9c8c61fdf1972ba98-players@3x.png";